<script>
/**
 * @overview 根组件
 *
 * @author  huojinzhao
 */

export default {
  name: "App",
};
</script>

<template>
  <router-view />
</template>

<style lang="postcss">

</style>

